(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/app/eid-sign/assets/javascripts/eidsign.js') >= 0) return;  svs.modules.push('/components/app/eid-sign/assets/javascripts/eidsign.js');
"use strict";

var _this = void 0;

const eidSign = svs => {
  'use strict';

  const MODE = svs.app.eidSign.constants.MODE;
  const ACTION_TYPE = {
    SUSPENSION: 0,
    SUBSCRIPTION: 1
  };
  const _svs$ui$dialog = svs.ui.dialog,
    Confirm = _svs$ui$dialog.Confirm,
    api = _svs$ui$dialog.api;
  const isProd = svs.app.eidSign.isProd;
  const logger = svs.core.log.getLogger('app:eidSign');
  let checker;
  let mode = MODE.BANKID;
  let qrCodeRetries = svs.app.eidSign.bankid.constants.INITIAL_QRCODE_RETRIES;
  let debitPermissionData;

  let timeoutId = 0;

  let timeLeft = 30;

  const getBankIDStartParams = token => {
    const autoStartToken = token;
    const isNativeApp = svs.utils.ns.isNamespace('svs.core.config.data.svsconfig.isNativeApp') ? svs.core.config.data.svsconfig.isNativeApp : false;
    if (svs.core.detect.os.iOS()) {
      if (isNativeApp && svs.core.detect.tenant('tb')) {
        return "bankid:///?autostarttoken=".concat(autoStartToken, "&redirect=").concat(encodeURIComponent(window.location.href.replace(/https?/i, 'spelbutiken.bankid')));
      }
      return "https://app.bankid.com/?autostarttoken=".concat(autoStartToken, "&redirect=null");
    }
    return "bankid:///?autostarttoken=".concat(autoStartToken, "&redirect=null");
  };



  const getFrejaEidStartParams = authRef => {
    let url;
    if (svs.core.detect.os.android()) {
      url = "frejaeid://bindUserToTransaction?transactionReference=".concat(authRef);
    } else if (svs.core.detect.formfactor.desktop() && !svs.core.detect.os.iOS()) {
      url = "frejaeid://bindUserToTransaction?transactionReference=".concat(authRef);
    } else {
      url = "frejaeid://bindUserToTransaction?transactionReference=".concat(authRef);
    }
    svs.app.eidSign.logger.debug("Freja eID start url: ".concat(url));
    return url;
  };

  const nextMultipleOf10 = num => Math.ceil(num / 10) * 10;

  const setScreenReaderTimeLeft = timeLeftText => {
    const currentTime = new Date();
    const formattedTime = "kl. ".concat(currentTime.getHours(), ":").concat(currentTime.getMinutes().toString().padStart(2, '0'), ".").concat(currentTime.getSeconds().toString().padStart(2, '0'));
    logger.debug("".concat(formattedTime, " - ").concat(timeLeftText));
    const srElem = document.querySelector('.screen-reader-time-left');
    if (srElem) srElem.innerHTML = timeLeftText;
  };

  const updateTimeLeft = () => {
    if (timeLeft === 0) {
      setTimeout(() => {
        const restartBtn = document.querySelector('.js-restart-btn');
        if (restartBtn) restartBtn.focus();
      }, 3500);
    }
    const timeLeftInfoElem = document.querySelector('.time-left-info');
    if (timeLeftInfoElem) timeLeftInfoElem.style.display = 'block';
    setScreenReaderTimeLeft("Tid kvar: ".concat(nextMultipleOf10(timeLeft), " sekunder"));
    const timeLeftElem = document.querySelector('.time-left');
    if (timeLeftElem) timeLeftElem.innerHTML = timeLeft;
  };

  const calculateTimeLeft = () => {
    let expected = Date.now() + 1000;
    const SECOND = 1000;
    const tick = () => {
      clearTimeout(timeoutId);
      timeLeft = Math.max(timeLeft - 1, 0);
      const drift = Date.now() - expected;
      expected += SECOND;
      updateTimeLeft();
      if (timeLeft > 0) {
        timeoutId = setTimeout(tick, SECOND - drift);
      }
    };
    timeoutId = setTimeout(tick, SECOND);
  };

  const startShowingTimeLeft = () => {
    if (qrCodeRetries === 0) {
      timeLeft = 30;
      updateTimeLeft();
      calculateTimeLeft();
    } else if (qrCodeRetries % 2 === 1) {
      const minutesLeft = Math.ceil(qrCodeRetries / 2);
      const timeLeftInfo = "Tid kvar: ".concat(minutesLeft, " ").concat(minutesLeft > 1 ? 'minuter' : 'minut');
      setScreenReaderTimeLeft(timeLeftInfo);
    }
  };

  const retry = (options, errorFn) => {
    const successFn = response => {
      checker.token = response.autoStartToken || response.authRef;
      const openEidUrlElem = document.querySelector('.open-eid-url');
      if (openEidUrlElem) {
        openEidUrlElem.setAttribute('href', mode === MODE.BANKID ? getBankIDStartParams(checker.token) : getFrejaEidStartParams(checker.token));
      }
      checker.startPolling();
      startShowingTimeLeft();
    };
    if (qrCodeRetries > 0) {
      qrCodeRetries -= 1;
      logger.info("Received customer scan timeout when doing eId signing, retrying ".concat(mode, ". Retries left: ").concat(qrCodeRetries));
      if (options.actionType === ACTION_TYPE.SUSPENSION) {
        if (mode === MODE.BANKID) {
          callAuthenticateBankIdApi(successFn, errorFn);
        } else if (mode === MODE.FREJA) {
          callAuthenticateFrejaEidApi(successFn, errorFn);
        }
      } else {
        callCreateDebitPermissonBankIdApi(successFn, errorFn);
      }
    } else if (qrCodeRetries === 0) {
      const qrElem = document.querySelector('.qr-code');
      if (qrElem) {
        qrElem.innerHTML = 'Inloggningen tog för lång tid.';
      }
      document.querySelectorAll('.info-text, .eid-url').forEach(el => {
        el.style.display = 'none';
      });
    }
  };

  const getLoaderDiv = () => '<div class="js-loader-container relative"></div>';

  const startLoader = () => {
    const loader = new svs.ui.Loader('.js-loader-container');
    loader.show(200, 'inverted');
  };

  const prepareStart = () => {
    const timeLeftInfoElem = document.querySelector('.time-left-info');
    const infoTextElem = document.querySelector('.info-text');
    const eIdUrlElem = document.querySelector('.eid-url');

    qrCodeRetries = mode === MODE.BANKID ? svs.app.eidSign.bankid.constants.INITIAL_QRCODE_RETRIES : svs.app.eidSign.freja.constants.INITIAL_QRCODE_RETRIES;
    clearTimeout(timeoutId);

    if (timeLeftInfoElem) {
      timeLeftInfoElem.style.display = 'none';
    }
    if (infoTextElem) {
      infoTextElem.style.display = '';
    }
    if (eIdUrlElem) {
      eIdUrlElem.style.display = '';
    }
  };

  const cancelPolling = () => {
    checker.stopPolling();

    qrCodeRetries = mode === MODE.BANKID ? svs.app.eidSign.bankid.constants.INITIAL_QRCODE_RETRIES : svs.app.eidSign.freja.constants.INITIAL_QRCODE_RETRIES;
  };

  const restart = function () {
    let actionType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ACTION_TYPE.SUSPENSION;
    let errorFn = arguments.length > 1 ? arguments[1] : undefined;
    const successFn = response => {
      prepareStart();
      checker.token = response.autoStartToken || response.authRef;
      if (mode === MODE.FREJA) {
        checker.qrCodeGenerate(getFrejaEidStartParams(checker.token));
      }
      const openEidUrlElem = document.querySelector('.open-eid-url');
      if (openEidUrlElem) {
        openEidUrlElem.setAttribute('href', mode === MODE.BANKID ? getBankIDStartParams(checker.token) : getFrejaEidStartParams(checker.token));
      }
      checker.startPolling();
    };
    if (actionType === ACTION_TYPE.SUSPENSION) {
      if (mode === MODE.BANKID) {
        callAuthenticateBankIdApi(successFn, errorFn);
      } else if (mode === MODE.FREJA) {
        callAuthenticateFrejaEidApi(successFn, errorFn);
      }
    } else if (actionType === ACTION_TYPE.SUBSCRIPTION) {
      callCreateDebitPermissonBankIdApi(successFn, errorFn);
    }
  };

  const bankidErrorHandler = (actionType, xhr, failEvent) => {
    let errorCode;
    let errorMessage;
    if (svs.utils.ns.isNamespace('responseJSON.error.code', xhr || {})) {
      errorCode = xhr.responseJSON.error.code;
    }
    switch (errorCode) {
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
      case 6:
      case 8:
      case 9:
      case 10:
      case 12:
      case 13:
      case 14:
      case 15:
      case 18:
      case 19:
      case 20:
      case 41:
      case 42:
      case 43:
      case 46:
      case 47:
      case 48:
      case 49:
      case 53:
      case 54:
      case 55:
        errorMessage = actionType === ACTION_TYPE.SUSPENSION ? 'Det går inte att verifiera din identitet just nu, var vänlig försök igen lite senare.' : 'Det går inte att skapa autogiromedgivande just nu, var vänlig försök igen lite senare.';
        break;
      case 56:
        errorMessage = 'BankID-appen svarar inte. Kontrollera att den är startad och att du har internetanslutning. ...';
        break;
      case 7:
      case 11:
      case 16:
      case 17:
        errorMessage = actionType === ACTION_TYPE.SUSPENSION ? 'Kan inte verifiera din identitet, var vänlig kontakta Kundservice 0770 - 11 11 11' : 'Kan inte skapa autogiromedgivande, var vänlig kontakta Kundservice 0770 - 11 11 11';
        break;
      case 30:
        errorMessage = actionType === ACTION_TYPE.SUSPENSION ? 'Du kan inte bekräfta en spelpaus åt någon annan' : 'Du kan inte skapa autogiromedgivande åt någon annan';
        break;
      case 44:
        errorMessage = actionType === ACTION_TYPE.SUSPENSION ? 'Det går inte att verifiera din identitet just nu, prova att uppdatera BankID appen.' : 'Det går inte att skapa autogiromedgivande just nu, prova att uppdatera BankID appen.';
        break;
      case 45:
        errorMessage = 'Det BankID du försöker använda är för gammalt eller spärrat...';
        break;
      case 50:
        errorMessage = actionType === ACTION_TYPE.SUSPENSION ? 'Verifiering avbruten, var vänlig försök igen' : 'Skapandet av autogiromedgivande avbruten, var vänlig försök igen';
        break;
      case 51:
      case 52:
        {
          svs.app.eidSign.logger.debug('User cancelled');
          const message = actionType === ACTION_TYPE.SUSPENSION ? 'Bekräftelse av spelpaus avbröts' : 'Skapandet av autogiromedgivande avbröts';
          const type = actionType === ACTION_TYPE.SUSPENSION ? svs.ui.dialog.area.POPUP : svs.ui.dialog.area.TOASTER;
          const errorDialog = new svs.ui.dialog.Confirm({
            area: type,
            branding: svs.ui.dialog.branding[svs.core.detect.tenant('lb') ? 'SPORT' : 'TUR'],
            type: svs.ui.dialog.type.ERROR,
            title: message,
            actions: [{
              title: 'Okej'
            }]
          });
          svs.ui.dialog.api.add(errorDialog);
          if (failEvent) svs.components.analytics.trackEvent(failEvent);
          return;
        }
      default:
        svs.app.eidSign.logger.error('Unhandled eidSign error', xhr);
        errorMessage = actionType === ACTION_TYPE.SUSPENSION ? 'Det går inte att verifiera din identitet just nu, var vänlig försök igen lite senare.' : 'Det går inte att skapa autogiromedgivande just nu, var vänlig försök igen lite senare.';
    }
    if (errorMessage) {
      const loggerInfo = actionType === ACTION_TYPE.SUSPENSION ? 'Suspension request with bankid failure' : 'Direct debit permission request with bankid failure';
      const title = actionType === ACTION_TYPE.SUSPENSION ? 'Misslyckad verifiering' : 'Misslyckat autogiromedgivande';
      svs.app.eidSign.logger.info(loggerInfo);
      const standardErrorDialog = new svs.ui.dialog.Confirm({
        branding: svs.ui.dialog.branding.TUR,
        type: svs.ui.dialog.type.ERROR,
        title,
        message: [{
          type: svs.ui.dialog.message.TEXT,
          text: errorMessage
        }],
        actions: [{
          title: 'Okej'
        }]
      });
      svs.ui.dialog.api.close(); 
      svs.ui.dialog.api.add(standardErrorDialog); 
    }
  };

  const frejaeidErrorHandler = (actionType, xhr, failEvent) => {
    let errorDialog;
    let errorCode;
    let errorMessage;
    let message = '';
    let type;
    if (svs.utils.ns.isNamespace('responseJSON.error.code', xhr || {})) {
      errorCode = xhr.responseJSON.error.code;
    }
    switch (errorCode) {
      case 1:
        if (actionType === ACTION_TYPE.SUSPENSION) {
          errorMessage = 'Det går inte att verifiera din identitet just nu, var vänlig försök igen lite senare eller kontakta Kundservice 0770 - 11 11 11';
        } else {
          errorMessage = 'Det går inte att skapa autogiromedgivande just nu, var vänlig försök igen lite senare eller kontakta Kundservice 0770 - 11 11 11';
        }
        break;
      case 51:
        svs.app.eidSign.logger.debug('User cancelled');
        if (actionType === ACTION_TYPE.SUSPENSION) {
          message = 'Bekräftelse av spelpaus avbröts';
          type = svs.ui.dialog.area.POPUP;
        } else {
          message = 'Skapandet av autogiromedgivande avbröts';
          type = svs.ui.dialog.area.TOASTER;
        }
        errorDialog = new svs.ui.dialog.Confirm({
          area: type,
          type: svs.ui.dialog.type.ERROR,
          autoClose: svs.ui.dialog.autoClose.MEDIUM,
          title: message,
          actions: [{
            title: 'Okej'
          }]
        });
        svs.ui.dialog.api.add(errorDialog); 
        if (failEvent) {
          svs.components.analytics.trackEvent(failEvent);
        }
        break;
      default:
        svs.app.eidSign.logger.error('Unhandled freja eid error', xhr);
        if (actionType === ACTION_TYPE.SUSPENSION) {
          errorMessage = 'Det går inte att verifiera din identitet just nu, var vänlig försök igen lite senare eller kontakta Kundservice 0770 - 11 11 11';
        } else {
          errorMessage = 'Det går inte att skapa autogiromedgivande just nu, var vänlig försök igen lite senare eller kontakta Kundservice 0770 - 11 11 11';
        }
    }
    if (errorMessage) {
      let loggerInfo = '';
      let title = '';
      if (actionType === ACTION_TYPE.SUSPENSION) {
        loggerInfo = 'Suspension request with frejaeid failure';
        title = 'Misslyckad verifiering';
      } else {
        loggerInfo = 'Direct debit permission request with frejaeid failure';
        title = 'Misslyckat autogiromedgivande';
      }
      svs.app.eidSign.logger.info(loggerInfo);
      const _dialog = new svs.ui.dialog.Confirm({
        branding: svs.ui.dialog.branding.TUR,
        type: svs.ui.dialog.type.ERROR,
        title,
        message: [{
          type: svs.ui.dialog.message.TEXT,
          text: errorMessage
        }],
        actions: [{
          title: 'Okej'
        }]
      });
      svs.ui.dialog.api.close(); 
      svs.ui.dialog.api.add(_dialog); 
    }
  };

  const showEIdProgress = (options, successFn, errorFn, context, successEvent, response) => {
    const shouldAutoRedirectMobile = Object.keys(options).indexOf('shouldAutoRedirectMobile') !== -1 ? options.shouldAutoRedirectMobile : true;
    checker = new svs.app.eidSign.Checker({
      token: response.autoStartToken || response.authRef,
      mode
    });
    if (options.shouldShowAuthToken) {
      logger.info("Auth ID: ".concat(checker.token));
    }
    const isMobile = svs.core.detect.formfactor.mobile();
    const desktopTextdefault = 'Skanna QR-koden med BankID-appen eller starta BankID på den här enheten.';
    const desktopText = (options === null || options === void 0 ? void 0 : options.desktopText) || desktopTextdefault;
    const infoText = isMobile ? mode === MODE.FREJA ? 'Försöker starta Freja eID-appen.' : 'Försöker starta BankID-appen.' : mode === MODE.FREJA ? 'Skanna QR-koden med Freja eID-appen' : desktopText;
    const eIdTemplate = svs.app.eid_sign.templates.eid_sign({
      infoText,
      isBankId: mode === MODE.BANKID,
      openBankIdUrl: getBankIDStartParams(checker.token) 
    });

    const getActions = () => svs.core.detect.formfactor.mobile() ? [{
      title: 'Avbryt',
      callback: () => {
        cancelPolling();
        errorFn.call(context, {
          responseJSON: {
            error: {
              code: 51
            }
          }
        });
        confirmDialog.close();
      }
    }, {
      title: mode === MODE.FREJA ? 'Öppna Freja eID-appen' : 'Öppna BankID-appen',
      callback: () => {
        checker.startPolling();
        window.location.href = mode === MODE.FREJA ? getFrejaEidStartParams(checker.token) : getBankIDStartParams(checker.token);
      }
    }] : [{
      title: 'Avbryt',
      callback: () => {
        cancelPolling();
        errorFn.call(context, {
          responseJSON: {
            error: {
              code: 51
            }
          }
        });
        confirmDialog.close();
      }
    }];
    const confirmDialog = new Confirm({
      branding: svs.ui.dialog.branding[svs.utils.branding.siteWide()],
      icon: options.icon || 'mobile',
      allowDimmerClick: false,
      title: (options === null || options === void 0 ? void 0 : options.title) || 'BankID',
      message: [{
        type: svs.ui.dialog.message.TEXT,
        text: eIdTemplate,
        align: svs.ui.dialog.message.align.CENTER
      }],
      actions: getActions()
    });
    setTimeout(() => {
      if (isMobile) {
        startLoader();
      } else {
        checker.qrCodeGenerate(mode === MODE.BANKID ? response.qrData : getFrejaEidStartParams(response.authRef));
      }
    }, 100);
    checker.startPolling();
    api.add(confirmDialog);
    checker.model.once('postToken', (model, value) => {
      confirmDialog.close();
      successFn && successFn.call(context, {
        postToken: value
      });
      if (successEvent) {
        svs.components.analytics.trackEvent(successEvent);
      }
    });
    checker.model.once('error', (model, value) => {
      confirmDialog.close();
      errorFn.call(context, value);
    });
    checker.model.on('retry', () => {
      retry(options, errorFn);
    });
    checker.model.on('progressText', (model, value) => {
      const qrElem = document.querySelector('.qr-code');
      if (qrElem) qrElem.innerHTML = '';
      if (qrElem) qrElem.innerHTML = value;
      const bankidUrlElem = document.querySelector('.eid-url');
      if (bankidUrlElem) bankidUrlElem.style.display = 'none';
      const infoTextElem = document.querySelector('.info-text');
      if (infoTextElem) infoTextElem.innerHTML = getLoaderDiv();
      startLoader();
    });

    const restartBtn = document.querySelector('.js-restart-btn');
    if (restartBtn) {
      const restartBtnClone = restartBtn.cloneNode(true);
      restartBtn.parentNode.replaceChild(restartBtnClone, restartBtn);
      restartBtnClone.addEventListener('click', () => {
        cancelPolling();
        restart(options.actionType, errorFn);
      });
    }

    if (isMobile && shouldAutoRedirectMobile) {
      window.location.href = mode === MODE.FREJA ? getFrejaEidStartParams(checker.token) : getBankIDStartParams(checker.token);
    }
  };

  const callAuthenticateFrejaEidApi = (successFn, errorFn) => {
    svs.core.jupiter.call({
      path: '/player/1/frejaeid/initauthsign',
      method: 'POST',
      data: {},
      context: void 0
    }, successFn, errorFn);
  };

  const callAuthenticateBankIdApi = (successFn, errorFn) => {
    svs.core.jupiter.call({
      path: '/player/1/authenticatesign',
      method: 'POST',
      data: {},
      context: void 0
    }, successFn, errorFn);
  };

  const callCreateDebitPermissonBankIdApi = (successFn, errorFn) => {
    svs.core.jupiter.call({
      path: '/player/1/sign',
      method: 'POST',
      data: debitPermissionData,
      context: void 0
    }, successFn, errorFn);
  };

  const authenticate = function () {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let successFn = arguments.length > 1 ? arguments[1] : undefined;
    let errorFn = arguments.length > 2 ? arguments[2] : undefined;
    let context = arguments.length > 3 ? arguments[3] : undefined;
    let successEvent = arguments.length > 4 ? arguments[4] : undefined;
    let failEvent = arguments.length > 5 ? arguments[5] : undefined;
    const errFn = errorFn || (xhr => {
      if (mode === MODE.BANKID) {
        bankidErrorHandler(ACTION_TYPE.SUSPENSION, xhr, failEvent);
      } else if (mode === MODE.FREJA) {
        frejaeidErrorHandler(ACTION_TYPE.SUSPENSION, xhr, failEvent);
      }
    });
    prepareStart();
    options.actionType = ACTION_TYPE.SUSPENSION;
    options.title = options.title || 'Bekräfta spelpaus';
    if (!isProd) {
      options.shouldShowAuthToken = true;
    }
    const desktopTextdefault = mode === MODE.BANKID ? 'Skanna QR-koden med BankID-appen eller starta BankID på den här enheten.' : 'Starta Freja eID-appen på din mobil eller surfplatta. Klicka på QR-ikonen och läs av QR-koden ovan med kameran.';
    options.desktopText = (options === null || options === void 0 ? void 0 : options.desktopText) || desktopTextdefault;
    options.icon = options.icon || 'spelpaus';
    if (mode === MODE.BANKID) {
      callAuthenticateBankIdApi(showEIdProgress.bind(_this, options, successFn, errFn, context, successEvent), errFn);
    } else if (mode === MODE.FREJA) {
      callAuthenticateFrejaEidApi(showEIdProgress.bind(_this, options, successFn, errFn, context, successEvent), errFn);
    }
  };

  const authenticateBankId = function () {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let successFn = arguments.length > 1 ? arguments[1] : undefined;
    let errorFn = arguments.length > 2 ? arguments[2] : undefined;
    let context = arguments.length > 3 ? arguments[3] : undefined;
    let successEvent = arguments.length > 4 ? arguments[4] : undefined;
    let failEvent = arguments.length > 5 ? arguments[5] : undefined;
    mode = MODE.BANKID;

    authenticate(options, successFn, errorFn, context, successEvent, failEvent);
  };

  const authenticateFrejaEid = function () {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let successFn = arguments.length > 1 ? arguments[1] : undefined;
    let errorFn = arguments.length > 2 ? arguments[2] : undefined;
    let context = arguments.length > 3 ? arguments[3] : undefined;
    let successEvent = arguments.length > 4 ? arguments[4] : undefined;
    let failEvent = arguments.length > 5 ? arguments[5] : undefined;
    mode = MODE.FREJA;

    authenticate(options, successFn, errorFn, context, successEvent, failEvent);
  };

  const createDirectDebitPermissionBankId = (options, successFn, errorFn, context) => {
    const errFn = errorFn || (xhr => {
      bankidErrorHandler(ACTION_TYPE.SUBSCRIPTION, xhr);
    });
    options = options || {};
    options.actionType = ACTION_TYPE.SUBSCRIPTION;
    options.title = options.title || 'Bekräfta betalning med autogiro';
    options.icon = options.icon || 'subscription';
    mode = MODE.BANKID; 

    debitPermissionData = {
      bankAccount: options.bankAccount,
      bankName: options.bankName
    };
    callCreateDebitPermissonBankIdApi(showEIdProgress.bind(void 0, options, successFn, errFn, context, undefined), errFn);
  };

  svs.app.eidSign.suspensionDefaultErrorHandlerBankId = bankidErrorHandler.bind(void 0, ACTION_TYPE.SUSPENSION);
  svs.app.eidSign.subscriptionDefaultErrorHandlerBankId = bankidErrorHandler.bind(void 0, ACTION_TYPE.SUBSCRIPTION);
  svs.app.eidSign.verifySuspensionRequestBankId = authenticateBankId; 
  svs.app.eidSign.createDirectDebitPermissionBankId = createDirectDebitPermissionBankId; 

  svs.app.eidSign.suspensionDefaultErrorHandlerFrejaEid = frejaeidErrorHandler.bind(void 0, ACTION_TYPE.SUSPENSION);
  svs.app.eidSign.verifySuspensionRequestFrejaEid = authenticateFrejaEid; 
};
eidSign(svs);

 })(window);